/* TANLO PDP — quick add on the cross-sell cards and the colour cards (2026-10-12).
   Loaded by snippets/tanlo-pdp-qa-dialog, which every section with quick_add on renders — so it
   can be on the page twice, and initialises only once. Products come from every
   [data-tpdp-qa-data] script on the page; strings and the cart URL from [data-tpdp-qa-conf].

   - One click listener on document, so the buttons inside the loop clones (tanlo-pdp.js copies the
     cards at both ends of the strip) work exactly like the real ones.
   - A product with no options adds at once. Anything with a colour or size opens the picker
     dialog on the same page. Colour starts on the card's default variant; a size option (named in
     the section's skip_options) is never preselected. A colour card's button carries its own shade
     (data-pre-i/-v) and, with data-buybox, takes every other option from the buy box selection.
   - Same cart path as the main button: POST to the locale's /cart/add.js through window.fetch read
     at click time (Kaching patches fetch when it boots), then open the Kaching drawer if it has not
     opened itself within a second. */
(function () {
  'use strict';

  if (window.__tpdpQa) return;
  window.__tpdpQa = true;

  var dlg = document.querySelector('[data-tpdp-qa]');
  if (!dlg) return;
  function readJson(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  var D = { addUrl: '', t: {} }, P = {}, HEX = {};
  [].forEach.call(document.querySelectorAll('[data-tpdp-qa-conf]'), function (el) {
    var c = readJson(el);
    if (!c) return;
    if (!D.addUrl && c.addUrl) { D.addUrl = c.addUrl; D.t = c.t || {}; }
    String(c.hex || '').split(',').forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i > 0) HEX[pair.slice(0, i).trim().toLowerCase()] = pair.slice(i + 1).trim();
    });
  });
  [].forEach.call(document.querySelectorAll('[data-tpdp-qa-data]'), function (el) {
    var d = readJson(el);
    if (d && d.p) Object.keys(d.p).forEach(function (h) { P[h] = d.p[h]; });
  });
  var T = D.t;

  // The shop prints "€" + amount_with_comma_separator, and the cards drop trailing zeros.
  function money(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return '€' + s;
  }

  /* ---------- cart ---------- */
  function drawerOpened() {
    return !!document.querySelector('kaching-cart[open], .kaching-cart--open, [data-kaching-cart-open="true"]');
  }
  function nudgeDrawer() {
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
        window.kachingCartApi.openCart({ refetchCart: true });
        return;
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('kaching-cart:open', { detail: { cartOpenSource: 'add-to-cart' } }));
    } catch (e) {}
  }
  function addToCart(id) {
    var opened = false;
    function seen() { opened = true; }
    document.addEventListener('kaching-cart:open', seen, { once: true });
    var body = new FormData();
    body.set('id', String(id));
    body.set('quantity', '1');
    return window.fetch(D.addUrl || '/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) return res.json().catch(function () { return {}; }).then(function (j) { throw new Error((j && j.description) || T.err); });
      return res.json();
    }).then(function (r) {
      setTimeout(function () {
        if (!opened && !drawerOpened()) nudgeDrawer();
        document.removeEventListener('kaching-cart:open', seen);
      }, 1000);
      return r;
    }, function (e) {
      document.removeEventListener('kaching-cart:open', seen);
      throw e;
    });
  }

  /* ---------- picker ---------- */
  var elImg = dlg.querySelector('[data-tpdp-qa-img]');
  var elTitle = dlg.querySelector('[data-tpdp-qa-title]');
  var elPrice = dlg.querySelector('[data-tpdp-qa-price]');
  var elOpts = dlg.querySelector('[data-tpdp-qa-opts]');
  var elAdd = dlg.querySelector('[data-tpdp-qa-add]');
  var elErr = dlg.querySelector('[data-tpdp-qa-err]');
  var cur = null;   // product data
  var sel = [];     // chosen value per option, null = not chosen yet

  function variantOf(s) {
    for (var i = 0; i < cur.v.length; i++) {
      var v = cur.v[i], ok = true;
      for (var j = 0; j < s.length; j++) { if (v.o[j] !== s[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  // A value is only greyed out when no combination with it is in stock at all, so a shopper can
  // never be trapped by an earlier choice. A sold-out combination shows on the button instead.
  function valueInStock(oi, val) {
    return cur.v.some(function (v) { return v.a && v.o[oi] === val; });
  }

  function render() {
    elOpts.innerHTML = '';
    cur.o.forEach(function (opt, oi) {
      var wrap = document.createElement('div');
      wrap.className = 'tpdp-opt';
      var lab = document.createElement('div');
      lab.className = 'tpdp-opt__label';
      lab.appendChild(document.createTextNode(opt.n));
      if (sel[oi] != null) {
        var vv = document.createElement('span');
        vv.className = 'tpdp-opt__value';
        vv.textContent = sel[oi];
        lab.appendChild(vv);
      }
      wrap.appendChild(lab);
      var row = document.createElement('div');
      row.className = 'tpdp-chips';
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', opt.n);
      opt.v.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tpdp-chip';
        b.setAttribute('aria-pressed', sel[oi] === val ? 'true' : 'false');
        var hex = opt.s ? '' : HEX[String(val).toLowerCase()];
        if (hex) {
          var dot = document.createElement('span');
          dot.className = 'tpdp-qa__dot';
          dot.style.setProperty('--sw', hex);
          b.appendChild(dot);
        }
        b.appendChild(document.createTextNode(val));
        if (!valueInStock(oi, val)) { b.disabled = true; b.setAttribute('data-soldout', '1'); }
        b.addEventListener('click', function () {
          sel[oi] = val;
          if (elErr) elErr.hidden = true;
          render();
        });
        row.appendChild(b);
      });
      wrap.appendChild(row);
      elOpts.appendChild(wrap);
    });

    var complete = sel.every(function (x) { return x != null; });
    var v = complete ? variantOf(sel) : null;
    var shown = v || variantOf(sel.map(function (x, i) { return x != null ? x : cur.v[0].o[i]; })) || cur.v[0];
    elPrice.textContent = money((v || shown).p);
    var img = (v && v.i) || (shown && shown.i) || cur.img;
    if (img) elImg.src = img;

    if (!complete) {
      elAdd.disabled = true;
      elAdd.textContent = T.size;
    } else if (!v || !v.a) {
      elAdd.disabled = true;
      elAdd.textContent = T.sold;
    } else {
      elAdd.disabled = false;
      elAdd.textContent = T.add;
    }
  }

  // What the buy box currently has for option oi (0-based), or null. Swatches and chips both carry
  // data-opt (1-based) and aria-pressed, set by tanlo-pdp.js.
  function buyBoxValue(oi) {
    var b = document.querySelector('[data-tpdp-main] [data-opt="' + (oi + 1) + '"][aria-pressed="true"]');
    return b ? b.getAttribute('data-value') : null;
  }

  function openPicker(p, btn) {
    cur = p;
    var dv = null;
    for (var i = 0; i < p.v.length; i++) { if (p.v[i].id === p.d) { dv = p.v[i]; break; } }
    var preI = btn && btn.hasAttribute('data-pre-i') ? parseInt(btn.getAttribute('data-pre-i'), 10) : -1;
    var preV = btn ? btn.getAttribute('data-pre-v') : null;
    var fromBox = !!(btn && btn.hasAttribute('data-buybox'));
    sel = p.o.map(function (opt, oi) {
      var ok = function (v) { return v != null && opt.v.indexOf(v) !== -1; };
      if (oi === preI && ok(preV)) return preV;
      if (opt.s) return opt.v.length === 1 ? opt.v[0] : null;
      if (fromBox && ok(buyBoxValue(oi))) return buyBoxValue(oi);
      return dv ? dv.o[oi] : null;
    });
    elTitle.textContent = p.t;
    if (elErr) elErr.hidden = true;
    elAdd.removeAttribute('data-busy');
    render();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function closePicker() {
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  elAdd.addEventListener('click', function () {
    if (!cur || elAdd.disabled || elAdd.getAttribute('data-busy') === '1') return;
    var v = variantOf(sel);
    if (!v || !v.a) return;
    elAdd.setAttribute('data-busy', '1');
    addToCart(v.id).then(function () {
      closePicker();
    }).catch(function (e) {
      if (elErr) { elErr.textContent = (e && e.message) || T.err; elErr.hidden = false; }
    }).then(function () {
      elAdd.removeAttribute('data-busy');
    });
  });
  dlg.querySelector('[data-tpdp-qa-close]').addEventListener('click', closePicker);
  // A click on the backdrop lands on the <dialog> itself, never on its inner panel.
  dlg.addEventListener('click', function (e) { if (e.target === dlg) closePicker(); });

  /* ---------- card buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tpdp-qa-btn]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.disabled || b.getAttribute('data-busy') === '1') return;
    var p = P[b.getAttribute('data-h')];
    if (!p) return;
    if (!p.single) { openPicker(p, b); return; }
    b.setAttribute('data-busy', '1');
    addToCart(p.d).then(function () {
      b.textContent = T.added;
      setTimeout(function () { b.textContent = T.card; }, 1800);
    }).catch(function () {
      b.textContent = T.err;
      setTimeout(function () { b.textContent = T.card; }, 2400);
    }).then(function () {
      b.removeAttribute('data-busy');
    });
  });
})();
